import $ from 'jquery';

$( document ).ready( function() {
	// Toggle registration fields on page load
	toggleRegistrationFields( $( '.checkbox-is-company input:checkbox' ).is( ':checked' ) );

	// Toggle registration fields on checkbox changes.
	$( '.checkbox-is-company input:checkbox' ).on( 'change', function() {
		const el = $( this );
		toggleRegistrationFields( el.is( ':checked' ) );
	} );

	// Copy the values of the shipping field inputs into the billing inputs on button click.
	$( '.copy-address-btn' ).on( 'click', function() {
		const adress1 = $( '#shipping-address-1' ).val(),
			adress2 = $( '#shipping-address-2' ).val(),
			postcode = $( '#shipping-postcode' ).val(),
			city = $( '#shipping-city' ).val(),
			companyName = $( '#shipping-receiver-name' ).val(),
			attention = $( '#shipping-attention' ).val(),
			country = $( '#shipping_country' ).val();

		$( '#billing-address-1' ).val( adress1 );
		$( '#billing-address-2' ).val( adress2 );
		$( '#billing-postcode' ).val( postcode );
		$( '#billing-city' ).val( city );
		$( '#billing-name' ).val( companyName );
		$( '#billing-attention' ).val( attention );
		$( '#billing_country' ).val( country );
	} );
} );

/**
 * Toggle company/private fields in the registration form
 *
 * @param {boolean} isCompany
 */
function toggleRegistrationFields( isCompany ) {
	if ( isCompany ) {
		// Hide personal fields
		$( '.customer-type-personal' ).hide();
		// Show company fields
		$( '.customer-type-company' ).show();
		// Make sure required field labels are correct
		$( '.required-if-personal .required' ).hide();
		$( '.required-if-company .required' ).show();
	} else {
		// Show personal fields
		$( '.customer-type-personal' ).show();
		// Hide company fields
		$( '.customer-type-company' ).hide();
		// Make sure required field labels are correct
		$( '.required-if-personal .required' ).show();
		$( '.required-if-company .required' ).hide();
	}
}
